<template>
    <!-- <Select  v-model="selectModel" style="width:100px;">
        <Option v-for="(item, index) in selectOptions" :value="index + 1" :key="item.value">{{ item.label }}</Option>
    </Select> -->
    <RadioGroup  v-model="selectModel" >
      <Radio v-for="(item, index) in selectOptions" :label="index + 1"  :key="item.value">{{ item.label }}</Radio>
    </RadioGroup>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      selectOptions: [
        {
          value: 54,
          label: "五不中"
        },
        {
          value: 55,
          label: "六不中"
        },
        {
          value: 56,
          label: "七不中"
        },
        {
          value: 57,
          label: "八不中"
        },
        {
          value: 58,
          label: "九不中"
        },
        {
          value: 59,
          label: "十不中"
        }
      ],
    };
  },
  computed: {
      ...mapGetters(['getliveshow']),
    selectModel: {
      get() {
        return this.getliveshow.proj;
      },
      set(val) {
        const value = this.selectOptions[val - 1]
        this.chg_liveshow_state({ title: value.label, donotcode: value.value, proj: val });
        this.upDate_reload()
      }
    },
  },
  created () {
    this.changeState()
  },
  methods: {
      ...mapActions(["chg_liveshow_state", 'upDate_reload']),
    changeState () {
      const value = this.selectOptions[0]
      this.chg_liveshow_state({ title: value.label, donotcode: value.value, proj: 1 });
      this.upDate_reload()
    }
  }
};
</script>